<div [ngStyle]="{ width: width + 'px' }" class="checklist-dropdown-wrapper">
  <ng-scrollbar #scrollbar class="std-scrollbar h-[200px]" appearance="native" orientation="vertical">
    <div [ngClass]="{ 'mr-3': scrollbar.isVerticallyScrollable() }">
      <span
        (click)="optionSelected({ action: SELECTED_OPTION.ADD })"
        class="row text-blue-700 text-sm font-semibold cursor-pointer"
        >New Checklist</span
      >
      @if (showNoChecklistOption) {
        <span class="row">
          <span
            (click)="optionSelected({ action: SELECTED_OPTION.DESELECT })"
            class="text-navy-700 font-semibold text-sm cursor-pointer"
          >
            No Checklist
          </span>
        </span>
      }
      @for (checklist of checkLists; track checklist; let index = $index) {
        <span class="row">
          <span
            (click)="optionSelected({ action: SELECTED_OPTION.SELECT, checklist })"
            class="text-navy-700 font-semibold text-sm cursor-pointer"
            [ngClass]="{
              'pointer-events-none !text-color_disabled': checklist.id === selectedId,
            }"
          >
            {{ checklist.name }}
          </span>
          <span
            [ngClass]="{
              'pointer-events-none opacity-50': checklist.id === selectedId,
            }"
            (click)="optionSelected({ action: SELECTED_OPTION.REMOVE, checklist, index }); $event.stopPropagation()"
          >
            @if (projectedContentTemplate) {
              <ng-container *ngTemplateOutlet="projectedContentTemplate"></ng-container>
            } @else {
              <span class="text-blue-700 text-sm font-semibold text-center cursor-pointer mr-1"> remove</span>
            }
          </span>
        </span>
      }
    </div>
  </ng-scrollbar>
</div>
